import Styled from "styled-components";

export const PaginationDiv = Styled.div`
display:flex;
justify-content:flex-end;
margin:2% 5% 0% 0%;
`;
